var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewDecline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.3335C6.68211 1.3335 5.39318 1.72448 4.29686 2.45703C3.20053 3.18957 2.34605 4.23078 1.84147 5.44895C1.33688 6.66713 1.20485 8.00756 1.46208 9.30077C1.71932 10.594 2.35425 11.7819 3.2866 12.7142C4.21895 13.6466 5.40684 14.2815 6.70004 14.5387C7.99325 14.796 9.33369 14.6639 10.5519 14.1593C11.77 13.6548 12.8112 12.8003 13.5438 11.704C14.2763 10.6076 14.6673 9.3187 14.6673 8.00016C14.6673 6.23205 13.9649 4.53635 12.7147 3.28611C11.4645 2.03587 9.76876 1.3335 8.00065 1.3335ZM9.97596 8.7409H6.02534C5.82889 8.7409 5.64047 8.66287 5.50156 8.52395C5.36264 8.38503 5.2846 8.19662 5.2846 8.00016C5.2846 7.80371 5.36264 7.61529 5.50156 7.47638C5.64047 7.33746 5.82889 7.25942 6.02534 7.25942H9.97596C10.1724 7.25942 10.3608 7.33746 10.4997 7.47638C10.6387 7.61529 10.7167 7.80371 10.7167 8.00016C10.7167 8.19662 10.6387 8.38503 10.4997 8.52395C10.3608 8.66287 10.1724 8.7409 9.97596 8.7409Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewDecline);
export default __webpack_public_path__ + "static/media/interview-decline.782a0ab590945f5b6e963f6212d7d349.svg";
export { ForwardRef as ReactComponent };